import { render, staticRenderFns } from "./CombinedAdminSettings.vue?vue&type=template&id=40272b74&"
import script from "./CombinedAdminSettings.vue?vue&type=script&lang=js&"
export * from "./CombinedAdminSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports